<template>
    <div class="relative">
        <img src="@/assets/img/home/home-footer.jpg" alt class="w-screen h-screen object-cover object-center overlay">
        <div class="absolute top-0 left-0 w-screen h-screen bg-black/30">
            <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-2">
                <div class="bg-white/70 rounded-xl min-h-[300px] h-fit min-w-[340px] sm:min-w-[500px] md:min-w-[600px] py-[16px] md:py-10 px-[12px] sm:px-[24px] flex flex-col text-black bg-blur">
                    <div class="flex mx-auto" style="align-items: center;">
                        <img class="w-16 sm:w-20" src="@/assets/img/logo.png" alt="Logo">
                        <h6 class="text-6xl mb-0 font-serif font-extrabold h-fit w-fit text-prime-color">HUET</h6>
                    </div>
                    <h6 class="text-center py-1 font-semibold md:text-lg">Chức năng dành cho cán bộ quản lý</h6>
                    <div class="w-full sm:w-[400px] md:w-[450px] mx-auto">
                        <div class="py-4 px-2 flex flex-col gap-[12px] sm:gap-5">
                            <b-input-group class="h-fit flex gap-2 login-form">
                                <svg class="my-auto ml-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: black;transform: ;msFilter:;"><path d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"></path></svg>
                                <b-form-input class="bg-transparent text-black border-0 pl-0" v-model="user" placeholder="Tên đăng nhập"></b-form-input>
                            </b-input-group>
                            <b-input-group class="h-fit flex gap-2 login-form">
                                <svg class="my-auto ml-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: black;transform: ;msFilter:;"><path d="M3.433 17.325 3.079 19.8a1 1 0 0 0 1.131 1.131l2.475-.354C7.06 20.524 8 18 8 18s.472.405.665.466c.412.13.813-.274.948-.684L10 16.01s.577.292.786.335c.266.055.524-.109.707-.293a.988.988 0 0 0 .241-.391L12 14.01s.675.187.906.214c.263.03.519-.104.707-.293l1.138-1.137a5.502 5.502 0 0 0 5.581-1.338 5.507 5.507 0 0 0 0-7.778 5.507 5.507 0 0 0-7.778 0 5.5 5.5 0 0 0-1.338 5.581l-7.501 7.5a.994.994 0 0 0-.282.566zM18.504 5.506a2.919 2.919 0 0 1 0 4.122l-4.122-4.122a2.919 2.919 0 0 1 4.122 0z"></path></svg>
                                <b-form-input class="bg-transparent text-black border-0 pl-0" v-model="password" type="password" placeholder="Mật khẩu"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="flex flex-col px-2">
                            <vue-page-transition name="fade">
                                <h6 v-if="!isForgetPassword" class="w-fit cursor-pointer ml-auto" @click="forgetPassword">Quên mật khẩu</h6>
                                <h6 v-else class="text-center font-semibold">Liên hệ quản trị viên để được cấp lại mật khẩu</h6>
                            </vue-page-transition>
                        </div>
                        <div class="grid grid-cols-2 gap-2 px-2 my-3">
                            <button @click="redirect('home')" class="btn btn-outline-dark py-2">Trang chủ</button>
                            <button @click="checkLogin" class="btn btn-dark py-2">Đăng nhập</button>
                        </div>
                        <a target="_blank" href="https://ums-huet.hueuni.edu.vn/" class="mb-3 mt-[12px] md:mt-6 flex gap-2 justify-center cursor-pointer" style="align-items: center;">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>
                            <h6 class="mb-0 text-black no-underline font-semibold">Sinh viên đăng nhập</h6>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data() {
        return {
            user: '',
            password: '',
            isForgetPassword: false,
            date: ''
        }
    },
    methods: {
        ...mapActions('user', ['CheckLogin']),
        redirect(page) {
            if (page == 'home') {
                this.$router.push({name: 'user'})
            }
            return
        },
        forgetPassword() {
            this.isForgetPassword = true
            setTimeout(() => {
                this.isForgetPassword = false
            }, 5000);
        },
        validate() {
            if (this.timeWrongInfoLogin >= 5) {
                localStorage.setItem("blockLoginDate", this.date)
                this.$swal.fire('Bạn đã nhập sai 5 lần<br>Chức năng đăng nhập đã khóa<br>Vui lòng thử lại sau', '', 'error')
                return false
            } else if (!this.user) {
                this.$swal.fire('Tên đăng nhập <br>không được để trống','', 'error')
                return false
            } else if (!this.password) {
                this.$swal.fire('Mật khẩu <br>không được để trống','', 'error')
                return false
            }
            return true
        },
        async checkLogin() {
            if(!this.validate()) return false
            let response = await this.CheckLogin({
                phone: this.user,
                password: this.password
            })
            if (response.code == 200) {
                await localStorage.removeItem("timeWrongInfoLogin")
                await localStorage.removeItem("blockLoginDate")
                await localStorage.setItem("loginStatus", 'true')
                await localStorage.setItem("userId", response.data)
                this.$router.push({name: 'admin.dashboard'})
            } else {
                this.timeWrongInfoLogin = await Number(this.timeWrongInfoLogin) + 1
                this.$swal.fire('Tên đăng nhập hoặc mật khẩu không đúng', '', 'error')
                this.password = ''
                localStorage.setItem("timeWrongInfoLogin", this.timeWrongInfoLogin)
                localStorage.setItem("loginStatus", 'false')
                localStorage.removeItem("userId", '')
            }
        },
    },
    async created() {
        // Get current date
        const now = new Date();
        const currentDate = now.getDate();
        const currentMonth = now.getMonth()+ 1;
        const currentYear = now.getFullYear();
        this.date = currentDate + '/' + currentMonth + '/' + currentYear;
        // check login status
        this.timeWrongInfoLogin = await localStorage.getItem("timeWrongInfoLogin") || 0
        if (this.timeWrongInfoLogin > 0) {
            const blockLoginDate = localStorage.getItem("blockLoginDate", this.date)
            if (blockLoginDate != this.date) {
                localStorage.setItem("timeWrongInfoLogin", '0')
                this.timeWrongInfoLogin = 0
            }
        }
        const loginStatus = await localStorage.getItem("loginStatus") || false
        if (loginStatus) {
            this.$router.push({name: 'admin.dashboard'})
        }
    },
}
</script>
<style lang="scss">
input {
    border: none;
    outline: none;
}
.form-control:focus {
  outline: none;
}
</style>

<style lang="scss" scoped>
.bg-blur {
    backdrop-filter: blur(5px);
}
.login-form {
    border-bottom: 1px solid black;
}
</style>